import { z } from 'zod'

import { m } from '@/lib/paraglide/messages'

/** Form "Hoàn tiền cho khách" ở tab công nợ (M-44); tối đa = tiền dư hiện có. */
export function createCustomerRefundSchema(maxCredit: number) {
    return z.object({
        amount: z
            .string()
            .trim()
            .min(1, m.refund_err_amount_required())
            .refine(
                (v) => Number.isFinite(Number(v)) && Number(v) > 0,
                m.refund_err_amount_required(),
            )
            .refine((v) => Number(v) <= maxCredit, {
                message: m.refund_err_amount_max({
                    max: maxCredit.toLocaleString('vi-VN'),
                }),
            }),
        payment_method: z
            .enum(['', 'cash', 'bank_transfer'])
            .refine((v) => v.length > 0, m.refund_err_method_required()),
        occurred_at: z
            .string()
            .regex(/^\d{4}-\d{2}-\d{2}$/, m.validation_invalid_date()),
        note: z.string().max(500),
    })
}

export type CustomerRefundFormValues = z.infer<
    ReturnType<typeof createCustomerRefundSchema>
>
